import './style.css'
import { App } from './core/App'

const container = document.querySelector<HTMLElement>('#scene-root')
const canvas = document.querySelector<HTMLCanvasElement>('#scene-canvas')

if (!container || !canvas) {
  throw new Error('The scene container or canvas is missing from index.html.')
}

const app = new App(container, canvas)
window.bedroomApp = app

void app.start().catch((error: unknown) => {
  if (!app.isDisposed) console.error('Bedroom scene failed to start.', error)
})

window.addEventListener('pagehide', () => app.dispose(), { once: true })

if (import.meta.hot) {
  import.meta.hot.dispose(() => app.dispose())
}
